import '@consumer/styles/global.scss'
import '@shared/greetingCards/fontDefinitions.css'
import 'windi.css'
import '@shared/timeZone'
import FloatingVue, { Tooltip } from 'floating-vue'

import { MotionPlugin } from '@vueuse/motion'
import { createApp } from '@shared/app'
import { createSSRApp as createAppWith } from 'vue'
import { maska } from 'maska'
import pages from '@consumer/pages'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { getConsumerStore } from '@consumer/services/store'

if (typeof window !== 'undefined' && window.location.pathname === '/checkout')
  import('@consumer/services/stripe').then(({ stripe }) => stripe.load())

if (document.getElementById('app')) {
  createApp('consumer', pages, (app) => {
    app
      .use(getConsumerStore())
      .directive('mask', maska)
      .component('GTooltip', Tooltip)
      .use(FloatingVue, {
        themes: {
          'top-nav-dropdown': { $extend: 'dropdown' },
        },
      })
      .use(MotionPlugin)
      .use(VueGoogleMaps, {
        load: {
          key: import.meta.env.GOOGLE_MAPS_JS_API_KEY,
        },
      })
  }, { createAppWith })
}
